export default "__VITE_ASSET__ByJ1wGsP__"